import { Component } from '@angular/core';

@Component({

  selector: 'app-footer',

  templateUrl: './footer.component.html',

  styleUrls: ['./footer.component.css']

})

export class FooterComponent {

lst_Contact = [
  {
    title: 'دفتر مرکزی - شرکت رایان اندیشه نصر',
    description: 'تهران، نارمک، بزرگراه شهید سلیمانی، بعد از چهارراه سرسبز، پلاک ۶۴۰، واحد ۸ - تلفن‌های تماس: ۲-۷۷۲۷۳۱۶۰-۰۲۱'
  },
  {
    title: 'نمایندگی هرمزگان',
    description: 'تلفن: ۳۳۳۸۱۴۰۸-۰۷۶ - همراه: ۰۹۱۷۷۵۶۳۳۴۵'
  },
  {
    title: 'نمایندگی مازندران',
    description: 'تلفن: ۳۳۳۹۱۲۰۰-۰۱۱ - همراه: ۰۹۱۱۸۶۴۴۲۸۸'
  },
  {
    title: 'نمایندگی اردبیل',
    description: 'همراه: ۰۹۱۴۱۹۷۳۲۵۶'
  },
  {
    title: 'نمایندگی آذربایجان غربی',
    description: 'همراه: ۰۹۱۲۸۴۷۰۸۹۸'
  },
  {
    title: 'نمایندگی اصفهان',
    description: 'همراه: ۰۹۱۳۸۰۷۰۵۱۱'
  },
  {
    title: 'نمایندگی خراسان شمالی',
    description: 'همراه: ۰۹۳۹۰۱۴۱۸۳۲'
  },
  {
    title: 'نمایندگی خراسان رضوی',
    description: 'همراه: ۰۹۱۵۶۴۴۱۷۱۳'
  },
  {
    title: 'نمایندگی خراسان جنوبی',
    description: 'همراه: ۰۹۱۵۵۳۴۵۴۵۶'
  },
  {
    title: 'نمایندگی قزوین',
    description: 'همراه: ۰۹۱۲۴۸۱۴۸۰۲'
  }
];


}
